define("Manage.LocationAddress.Model", [
  "Backbone",
  "Utils",
  "Singleton",
], function (Backbone, Utils, Singleton) {
  "use strict";

  var LocationAddressModel = Backbone.Model.extend({
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath("services/Manage.LocationAddress.Service.ss")
    ),
    idAttribute: "id",
  });

  return _.extend(LocationAddressModel, Singleton);
});
